// extracted by mini-css-extract-plugin
module.exports = {"form":"Checkout_form__2qDHd","control":"Checkout_control__RB6Yo","actions":"Checkout_actions__1Hxur","submit":"Checkout_submit__cddVl","invalid":"Checkout_invalid__3q7Y5"};